export class VehicleType{

    id:number;
    name;
    capacity : number;

    constructor(vehicleTypeResponse){
        this.id = vehicleTypeResponse.vehicletypeid;
        this.name = vehicleTypeResponse.name;
        this.capacity = vehicleTypeResponse.capacity;
    }
}